import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, catchError, mergeMap, throwError } from "rxjs";
// import { environment } from "src/environments/environment";
import { UserService } from "src/app/services/apis/user.service";
import { MultimediaService } from "src/app/services/apis/multimedia.service";
// import { storeToken } from "src/app/store/user/user.action";
import { Router } from "@angular/router";
import { RouteLocalizationPipe } from "src/app/pipes/route-localization.pipe";
import { ConfigService } from "src/app/services/config.service";
import { SharedService } from "src/app/services/shared.service";
import { TranslationService } from "src/app/i18n/translation.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private multimediaService: MultimediaService,
    private router: Router,
    private routeLocalizationPipe: RouteLocalizationPipe,
    private configService: ConfigService,
    private SharedService: SharedService,
    private TranslationService: TranslationService,    
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const baseURL = this.configService.baseURL;
    const baseURLParentLevel = baseURL ? new URL(baseURL).origin : '';

    let path = request.url;

    let isWithoutAPI_WORD = path.indexOf("QJET_APIS_BASE") !== -1;
    let url =
      path.indexOf("api/") !== -1 || isWithoutAPI_WORD
        ? isWithoutAPI_WORD
          ? baseURLParentLevel + path.replace("QJET_APIS_BASE", "")
          : baseURL + path
        : path;

    let modifiedRequest = request.clone({ url: url });
    let token = this.userService.getUserBearerToken();

    if (
      path.indexOf("api/Account/CSGetData") !== -1 ||
      path.indexOf("api/Account/QPGetData") !== -1 ||
      path.indexOf("InquireTransactionStatus") !== -1 ||
      path.indexOf("GetSiteUserWalletAmmount") !== -1 ||
      path.indexOf("api/account/SaveCardGetData") !== -1 ||
      path.indexOf("account/CSGetDataForSavedCard") !== -1 ||
      path.indexOf("api/Account/ProfileByToken") !== -1
    ) {
      const mobileTempToken =
        typeof window !== "undefined"
          ? localStorage.getItem("mobileToken")
          : "";
      if (mobileTempToken) token = mobileTempToken;
    }

    if (token)
      modifiedRequest = modifiedRequest.clone({
        headers: modifiedRequest.headers
          .set("BearerToken", token)
          .set("DevicePrint", this.userService.getUserDevicePrint())
          .set("AppID", '1')
          .set("DeviceID", '1')
          .set("DeviceTypeID", '1')
          .set("LanguageID", '1'),
      });

    modifiedRequest = modifiedRequest.clone({});

    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {        
        // Request failed with status code: Unauthorized
        if (error.status === 401 || error?.error?.text === 'Request failed with status code: Unauthorized') {
          // Handle token refresh here

          this.userService.clearUserData();

          if(typeof window !== 'undefined') {
            // location.reload();
            window.location.href = this.SharedService.getDomainURL() + `/${this.TranslationService.getSelectedLanguage()}`;
            // this.router.navigate([this.routeLocalizationPipe.transform('')]);

          }

          return throwError(error);

          // return this.refreshTokenAndRetry(modifiedRequest, next);
        } else {
          // TODO :: 404 ..
          return throwError(error);
        }
      })
    );

  }

  private refreshTokenAndRetry(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // TODO retry time 3..
    // const silentRequest: SilentRequest = {
    //   scopes: [],
    //   authority: b2cPolicies.authorities.signUpSignIn.authority,
    // };

    return this.multimediaService.getTokenByRefreshToken({}).pipe(
      mergeMap((response) => {

        const newToken = response.token?.toString() || "";
        typeof window !== 'undefined' ? localStorage.setItem('token', newToken) : null;
        this.userService.updateUserData({token: newToken});

        let modifiedRequest = request.clone({
          setHeaders: {
            BearerToken: newToken,
          },
        });

        // Retry the request with the new access token
        return next.handle(modifiedRequest);
      }),
      catchError((error) => {
        // Handle token refresh error
        return throwError(error);
      })
    );
  }

}
